import React, {
    Component,
} from 'react';
import ReactHighcharts from '../../../../CommonComponents/Highcharts';
import {
    computeChartStringKey,
    formatMoney,
} from './ProgressChartHelpers';
import OwnerDropdown from '../../OwnerDropdown/OwnerDropdownContainer';
import SplitTabs from '../../SplitTabs/SplitTabsContainer';
import Breakdown from '../Breakdown/BreakdownContainer';

export default class ProgressChartView extends Component {
    render() {
        const {
            isPrint,
            clientId,
            fpId,
            goalId,
            ownerIndex,
            breakdown,
            note,
            subgoalId,
            setSelectedOwnerIndex,
            chartData,
            hasChartData,
            principalName,
            spouseName,
            coverageLimit,
            currentCoverage,
            passiveIncome,
        } = this.props;

        return <div className="progress-chart-container NewFinancialPlan_Insurance_Disability">
            <SplitTabs
                isPrint={isPrint}
                clientId={clientId}
                goalId={goalId}
                subgoalId={subgoalId}
                tabs={[]}
                leftChildren={
                    <div>
                        {!isPrint && <OwnerDropdown
                            clientId={clientId}
                            goalId={goalId}
                            principalName={principalName}
                            spouseName={spouseName}
                            setSelectedIndex={setSelectedOwnerIndex}
                        />}
                        {hasChartData && <ReactHighcharts
                            autoResize={true}
                            className="progress-chart"
                            container={computeChartStringKey(
                                ownerIndex.toString(),
                                `${subgoalId}`,
                                fpId,
                                clientId
                            )}
                            options={chartData}
                        />}
                        {hasChartData && <ul className="legend hide-on-mobile-screens">
                            {passiveIncome.value >= 1 && <li className="passive-income">
                                <i />
                                Passive Income
                                <span>${formatMoney(passiveIncome.value)}</span>
                            </li>}
                            <li className="current-coverage">
                                <i />
                                Current Coverage
                                <span>${formatMoney(currentCoverage.value - passiveIncome.value)}</span>
                            </li>
                            <li className="coverage-gap">
                                <i />
                                Coverage Gap
                                <span>${formatMoney(coverageLimit.value - currentCoverage.value)}</span>
                            </li>
                            <li>
                                <i className="dash-line" />
                                Coverage Limit
                                <span>${formatMoney(coverageLimit.value)}</span>
                            </li>
                        </ul>}
                    </div>
                }
                rightChildren={
                    <Breakdown
                        clientId={clientId}
                        goalId={goalId}
                        subgoalId={subgoalId}
                        breakdown={breakdown}
                        note={note.Notes.find((note) => note.Name === "Level 1")}
                    />
                }
            />
        </div>;
    }
};
